var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12M3.729 3.021a.5.5 0 1 0-.708.708L5.293 6 3.02 8.271a.5.5 0 1 0 .708.708L6 6.707 8.271 8.98a.5.5 0 1 0 .708-.708L6.707 6 8.98 3.729a.5.5 0 1 0-.708-.708L6 5.293z",
    clipRule: "evenodd"
  })));
});
const SvgCloseCircleFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEyQzkuMzEzNzEgMTIgMTIgOS4zMTM3MSAxMiA2QzEyIDIuNjg2MjkgOS4zMTM3MSAwIDYgMEMyLjY4NjI5IDAgMCAyLjY4NjI5IDAgNkMwIDkuMzEzNzEgMi42ODYyOSAxMiA2IDEyWk0zLjcyODU1IDMuMDIxNDVDMy41MzMyOSAyLjgyNjE4IDMuMjE2NzEgMi44MjYxOCAzLjAyMTQ1IDMuMDIxNDVDMi44MjYxOCAzLjIxNjcxIDIuODI2MTggMy41MzMyOSAzLjAyMTQ1IDMuNzI4NTVMNS4yOTI4OSA2TDMuMDIxNDUgOC4yNzE0NUMyLjgyNjE4IDguNDY2NzEgMi44MjYxOCA4Ljc4MzI5IDMuMDIxNDUgOC45Nzg1NUMzLjIxNjcxIDkuMTczODIgMy41MzMyOSA5LjE3MzgyIDMuNzI4NTUgOC45Nzg1NUw2IDYuNzA3MTFMOC4yNzE0NSA4Ljk3ODU1QzguNDY2NzEgOS4xNzM4MiA4Ljc4MzI5IDkuMTczODIgOC45Nzg1NSA4Ljk3ODU1QzkuMTczODIgOC43ODMyOSA5LjE3MzgyIDguNDY2NzEgOC45Nzg1NSA4LjI3MTQ1TDYuNzA3MTEgNkw4Ljk3ODU1IDMuNzI4NTVDOS4xNzM4MiAzLjUzMzI5IDkuMTczODIgMy4yMTY3MSA4Ljk3ODU1IDMuMDIxNDVDOC43ODMyOSAyLjgyNjE4IDguNDY2NzEgMi44MjYxOCA4LjI3MTQ1IDMuMDIxNDVMNiA1LjI5Mjg5TDMuNzI4NTUgMy4wMjE0NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";